import { adminActionTypes } from "src/action_types/section_action_types";

export function selectWoundAlertRulesTablePageNumberAction(pageNumber) {
  return {
    type: adminActionTypes.selectWoundAlertRulesTablePageNumber,
    payload: pageNumber
  };
}
